export default "__VITE_ASSET__b5l_fome__"